import React from 'react';
import './App.css';
import { Header } from './Header';
import { Kilometer } from './Graphs/Kilometer';
import { Fuel } from './Graphs/Fuel'
import { Mileage } from './Graphs/Mileage';
import { Averagespeed } from './Graphs/Averagespeed';
import { Footer } from './Footer';
import { Element } from 'react-scroll';
import { Torque } from './Graphs/Torque';
import { Livespeed } from './Graphs/Livespeed';



function App() {
  return (
    <div className="App">
      <Header/>
       <Element name="section1" className="element">
      <Kilometer/>
      </Element>
      <Element name="section2" className="element">
      <Fuel/>
      </Element>
      <Element name="section3" className="element">
      <Mileage/>
      </Element>
      <Element name="section4" className="element">
      <Averagespeed/>
      </Element>
      <Element name="section5" className="element"> 
      <Livespeed/>
      </Element>
      <Element name="section6" className="element">
      <Torque/>
      </Element>
     
      
      <Footer/>
      
      
    </div>
  );
}

export default App;
